import script from "./redditTranslate.vue?vue&type=script&setup=true&lang=js"
export * from "./redditTranslate.vue?vue&type=script&setup=true&lang=js"

import "./redditTranslate.vue?vue&type=style&index=0&id=1e0e8ce8&lang=css"
import "./redditTranslate.vue?vue&type=style&index=1&id=1e0e8ce8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e0e8ce8"]])

export default __exports__